const valutizzaStringaONumero = function (
  variabileNonFormattataComeValuta,
  currencyText,
  nienteDecimali
) {
  //console.log(variabileNonFormattataComeValuta)
  let valore = variabileNonFormattataComeValuta;
  if (typeof variabileNonFormattataComeValuta === "string") {
    valore = parseFloat(variabileNonFormattataComeValuta);
  }
  if (nienteDecimali) {
    valore = parseInt(valore);
  }
  return valore.toLocaleString("it-IT", {
    style: "currency",
    currency: currencyText,
  });
};

export default valutizzaStringaONumero;
